import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrudImagenesComponent } from './crud-imagenes.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';

@NgModule({
  declarations: [CrudImagenesComponent],
  imports: [
    CommonModule,
    CarouselModule.forRoot(),
  ],
  exports: [CrudImagenesComponent]
})
export class CrudImagenesModule { }



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/main/crud-imagenes/crud-imagenes.module.ts